import React, { useMemo } from 'react';
import AuthService from '@/shared/services/AuthService';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import PropTypes from 'prop-types';

function MenuItemWithSecurity({ children, functionality, privilege, onSelect, id }) {
  const hasPermission = useMemo(
    () =>
      AuthService.hasPermission({
        functionality,
        privilege,
      }),
    [functionality, privilege],
  );
  if (!hasPermission) return null;

  return (
    <MenuItem onSelect={onSelect} id={id}>
      {children}
    </MenuItem>
  );
}

MenuItemWithSecurity.propTypes = {
  privilege: PropTypes.number.isRequired,
  functionality: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
};
export default MenuItemWithSecurity;
